import { render, staticRenderFns } from "./DeCode.vue?vue&type=template&id=89bd7018&scoped=true"
import script from "./DeCode.vue?vue&type=script&lang=js"
export * from "./DeCode.vue?vue&type=script&lang=js"
import style0 from "./DeCode.vue?vue&type=style&index=0&id=89bd7018&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89bd7018",
  null
  
)

export default component.exports